"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT = exports.REQUEST_PARTNER = exports.REQUEST_QUOTE = exports.REQUEST_REMOTE_TOOLS = exports.REQUEST_TRIAL = exports.REQUEST_SKU = exports.REQUEST_SEAT_BANNER = exports.REQUEST_ADDITIONAL_SEATS = exports.REQUEST_SEAT_UPGRADE_BANNER = exports.REQUEST_SEAT_UPGRADE = void 0;
var REQUEST_SEAT_UPGRADE = 'requestSeatUpgrade';
exports.REQUEST_SEAT_UPGRADE = REQUEST_SEAT_UPGRADE;
var REQUEST_SEAT_UPGRADE_BANNER = 'requestSeatUpgradeBanner';
exports.REQUEST_SEAT_UPGRADE_BANNER = REQUEST_SEAT_UPGRADE_BANNER;
var REQUEST_ADDITIONAL_SEATS = 'requestAdditionalSeats';
exports.REQUEST_ADDITIONAL_SEATS = REQUEST_ADDITIONAL_SEATS;
var REQUEST_SEAT_BANNER = 'requestSeatBanner';
exports.REQUEST_SEAT_BANNER = REQUEST_SEAT_BANNER;
var REQUEST_SKU = 'requestSKU';
exports.REQUEST_SKU = REQUEST_SKU;
var REQUEST_TRIAL = 'requestTrial';
exports.REQUEST_TRIAL = REQUEST_TRIAL;
var REQUEST_REMOTE_TOOLS = 'requestRemoteTools';
exports.REQUEST_REMOTE_TOOLS = REQUEST_REMOTE_TOOLS;
var REQUEST_QUOTE = 'requestQuote';
exports.REQUEST_QUOTE = REQUEST_QUOTE;
var REQUEST_PARTNER = 'requestPartnerScope';
exports.REQUEST_PARTNER = REQUEST_PARTNER;
var DEFAULT = 'default';
/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking

exports.DEFAULT = DEFAULT;

if (!!module && !!module.exports) {
  module.exports.default = module.exports;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/constants/AdminModalTypes.js
// module id = 141
// module chunks = 5 6